export default "__VITE_ASSET__B6iqG1tF__"